"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientService = void 0;
const socket_io_client_1 = require("socket.io-client");
const events_1 = require("../../enums/external/events");
const subject_service_1 = require("../internal/subject.service");
const events_2 = require("../../constants/internal/events");
const dynamic_service_1 = require("../internal/dynamic.service");
const interceptor_service_1 = require("../internal/interceptor.service");
const strategy_1 = require("../../constants/internal/strategy");
class ClientService {
    defaultAuthBlock;
    socketClient;
    subjectService;
    dynamicService;
    interceptorService;
    authBlock;
    api;
    constructor(socketServerHost, defaultAuthBlock) {
        this.defaultAuthBlock = defaultAuthBlock;
        this.socketClient = (0, socket_io_client_1.io)(socketServerHost, {
            autoConnect: true,
            upgrade: false,
            transports: ['websocket'],
        });
        this.authBlock = defaultAuthBlock;
        this.interceptorService = new interceptor_service_1.InterceptorService();
        this.subjectService = new subject_service_1.SubjectService(this.interceptorService, this);
        this.dynamicService = new dynamic_service_1.DynamicService(this.subjectService, this);
        this.api = this.dynamicService.generateModule(strategy_1.SOCKET_SUBSCRIBE_STRATEGY);
    }
    auth(authBlock = this.defaultAuthBlock) {
        this.authBlock = authBlock;
        this.socketClient.emit(events_1.SocketEvent.AUTH, authBlock);
    }
    logout() {
        this.authBlock = this.defaultAuthBlock;
        this.socketClient.emit(events_1.SocketEvent.LOGOUT, { id: this.socketClient.id });
    }
    join(target) {
        this.socketClient.emit(events_1.SocketEvent.JOIN, { auth: this.authBlock, target });
    }
    leave(target) {
        this.socketClient.emit(events_1.SocketEvent.LEAVE, { auth: this.authBlock, target });
    }
    send(target, event, payload = undefined) {
        this.socketClient.emit(event, { auth: this.authBlock, target, payload });
    }
    notify(event, target, payload) {
        this.join(target);
        this.send(target, event, payload);
        this.leave(target);
    }
    onInit(auth = false) {
        if (typeof auth === 'boolean' && auth) {
            this.auth();
        }
        if (typeof auth === 'object') {
            this.auth(auth);
        }
        events_2.SOCKET_BROADCAST_EVENTS.forEach((event) => {
            this.socketClient.on(event, (data) => {
                this.subjectService.trigger(event, data);
            });
        });
    }
    onDestroy() {
        this.interceptorService.clear();
        this.subjectService.unsubscribeAll();
        this.socketClient.offAny();
        this.socketClient.offAnyOutgoing();
        this.socketClient.disconnect();
    }
    get dynamic() {
        return this.api;
    }
    get interceptors() {
        return {
            add: this.interceptorService.add.bind(this.interceptorService),
            remove: this.interceptorService.remove.bind(this.interceptorService),
        };
    }
    get isConnected() {
        return this.socketClient.connected;
    }
}
exports.ClientService = ClientService;
